import { VersionT } from "../../../models/models";

const hasMXF = (version: VersionT[] = []) => {
    if (!version.length) return false;
    return !!(version.filter(version => version?.fileFormat?.toLocaleLowerCase() === 'mxf').length);
}

export default hasMXF;